(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-bundle-sales"] && !window.DesignMode) return;
  try {
    
  
  
  $('.swatch__input--bundle').change(function(){
    var dex = $('.swatch__input--bundle').index(this);
    
    var set_price = 0, variant_price = 0,unit='';

    $(`div[name="TGindex-`+dex+'"]').toggle(500);
    $(`div[name="TGindex-`+dex+'"]').next().toggle(500);

    $('.swatch__input--bundle:checked').each(function(index){
      unit = $(this).attr('data-price').slice(0,1);
      
      let old_string_price = Number($(this).attr('data-price').slice(1));
      let var_string_price = Number($(this).attr('data-variant-price').slice(1));
      set_price = set_price + old_string_price;
      variant_price = variant_price + var_string_price;
    })

    let new_price_string = unit + set_price.toFixed(2).toString()
    let new_var_string = unit + variant_price.toFixed(2).toString()
    $('.bundle-product__container-price .sale-price').html(new_price_string);
    $('.bundle-product__container-price .product__price--compare').html(new_var_string);
    console.log(new_var_string == new_price_string);
    console.log('123');
  })

  
  $('.bundle--addtoCart').on('click',function(){
    $(this).addClass('bundle--addtoCart-active');
    var formData = {
     'items': []
    };
    $('.swatch__input--bundle:checked').each(function(index){
      let data = {
        "id": Number($(this).attr('id')),
        "quantity": 1
      }
      formData.items[index] = data;
    })
    ajaxCart(formData);
  })
  
  function ajaxCart(data){
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      new theme.CartDrawer();
    })
    .then(() => {
      // console.log(theme.CartDrawer);
      $('.bundle--addtoCart.bundle--addtoCart-active').removeClass('bundle--addtoCart-active');
    })
    .catch((error) => {
      $('.bundle--addtoCart.bundle--addtoCart-active').removeClass('bundle--addtoCart-active');
      console.error('Error:', error);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
